import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class EntityService {

  static getRoot() {
    return ROOT;
  }

  static getMeasurementsForRange(dataTypeToken, entitySerialNumber, startTimestamp, endTimestamp) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}entities/measurement-data/${dataTypeToken}/${entitySerialNumber}?startAtDate=${startTimestamp}&endAtDate=${endTimestamp}`).then((data) => {
        resolve({ data: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }
  
  static getBySerialNumber(serialNumber) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}entities/${serialNumber}`).then((data) => {
        resolve({ entity: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static findAllForGrouping(groupingId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}entities/findByGrouping?groupingId=${groupingId}`).then((data) => {
        resolve({ entities: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getLastReceivedDataBySerialNumberAndDeviceType(serialNumber, deviceDataTypeToken) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}entities/${serialNumber}/last-received-data/${deviceDataTypeToken}`).then((data) => {
        resolve({ lastReceivedData: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getEventConfigurations(serialNumber) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}entities/${serialNumber}/event-configurations`).then((data) => {
        resolve({ configurations: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getExceededThresholds(serialNumber) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}entities/${serialNumber}/exceeded-thresholds`).then((data) => {
        resolve({ exceededThresholds: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

export default EntityService;